export default __webpack_public_path__ + "static/media/Floor_Plan_3D_Advanced.d3805ffa.jpg";